var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("NotificationPopup", { attrs: { items: _vm.notifications } }),
      _c(
        "router-view",
        _vm._b(
          {
            on: {
              refetch: function ($event) {
                return _vm.$emit("refetch")
              },
              signOut: function ($event) {
                return _vm.$emit("signOut")
              },
            },
          },
          "router-view",
          _vm.$attrs,
          false
        )
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }